var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"text"},[_c('TitleHacienda'),_c('ParagraphOne')],1),_c('div',{})])}
var staticRenderFns = []

export { render, staticRenderFns }